import apiClient from './apiClient';

// Interface pour les détails du pack
export interface Pack {
  id: number;
  productId: string;
  type: string;
  name: string;
  dataValue?: number;
  dataUnit?: string;
  dataDuration?: number;
  validityDuration?: number;
  validityDurationUnit?: string;
  countries?: string[];
}

// Interface pour le profil eSIM dans un sub-plan
export interface EsimProfileDetails {
  id: number;
  simSerial: string;
  status: 'ALLOCATED' | 'RELEASED' | 'SUSPENDED' | 'ENABLED';
  statusDate?: string;
  activationCode?: string;
  matchingId?: string;
  smdpAddress?: string;
  eid?: string;
  subscriberId?: number;
}

// Interface pour un sub-plan (structure API v1)
export interface SubPlan {
  id: number;
  startingDate?: string;
  endingDate?: string;
  externalSubscriptionId?: string;
  creationDateTime?: string;
  pack?: Pack;
  esimProfile?: EsimProfileDetails;
}

// Interface legacy pour compatibilité
export interface Subscription {
  id: number;
  subscriberId: number;
  packId: number;
  status: string;
  startDate: Date;
  endDate: Date;
  autoRenew: boolean;
  dataUsed: number;
  packDataLimit: number;
}

export const subscriptionService = {
  getAll: () => 
    apiClient.get('/subscriptions'),

  // Pour l'admin: récupérer les sub-plans d'un abonné spécifique
  getBySubscriber: (subscriberId: number) =>
    apiClient.get(`/v1/sub-plans/subscriber/${subscriberId}`),

  create: (subscription: Omit<Subscription, 'id'>) =>
    apiClient.post('/subscriptions', subscription),

  update: (id: number, subscription: Partial<Subscription>) =>
    apiClient.put(`/subscriptions/${id}`, subscription),

  cancel: (id: number) =>
    apiClient.post(`/subscriptions/${id}/cancel`),

  renew: (id: number) =>
    apiClient.post(`/subscriptions/${id}/renew`)
};